/**
 * Protected Route Component
 *
 * Оборачивает приватные маршруты, требующие аутентификации.
 * Редиректит на /login если пользователь не авторизован.
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSession } from '../context/SessionContext';
import { Container, Loader, Center, Stack, Text } from '@mantine/core';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useSession();

  // Показать loader пока проверяется сессия
  if (loading) {
    return (
      <Container size="sm" style={{ minHeight: '100vh' }}>
        <Center style={{ minHeight: '100vh' }}>
          <Stack align="center" gap="md">
            <Loader size="lg" />
            <Text c="dimmed">Проверка сессии...</Text>
          </Stack>
        </Center>
      </Container>
    );
  }

  // Редирект на login если не авторизован
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // TODO: Проверка must_change_password и редирект на /change-password
  // if (user && user.must_change_password) {
  //   return <Navigate to="/change-password" replace />;
  // }

  // Пользователь авторизован - показать контент
  return children;
};

export default ProtectedRoute;
